import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home";
import ALF from "./pages/Services/AssistedLiving/ALF.jsx";
import CustomPacking from "./pages/Services/CustomPacking/CustomPacking.jsx";
import Pharmacy from "./pages/Services/Pharmacy/Pharmacy.jsx";
import Trx from "./pages/Services/TransferRX/Trx.jsx";
import MedicalAdherence from "./pages/Services/MedicalAdherence/MedicalAdherence.jsx";
import MTheraphy from "./pages/Services/MedicationTheraphy/MTheraphy.jsx";
import SANC from "./pages/Services/SterileandNonCompounding/SANC.jsx";
import Immunizations from "./pages/Services/Immunizations/Immunizations.jsx";
import MDPP from "./pages/Services/MultiDosePillPackaging/MDPP.jsx";
import MSync from "./pages/Services/MedicationSync/MSync.jsx";
import MedInfo from "./pages/Resources/MedInfo/MedInfo.jsx";
import IVCP from "./pages/Resources/IndependentVsChainPharmacies/IVCP.jsx";
import MediacationPartD from "./pages/Resources/MedicationPartD/MedicationPartD.jsx";
import ALCPSP from "./pages/Resources/ALC-12/ALCPSP.jsx";
import VitaminsAreNecessary from "./pages/Resources/VitaminsAreNecessary/VitaminsAreNecessary.jsx";
import PersonalAttention from "./pages/Resources/PersonalAttention/PersonalAttention";


function App() {
  return (
    
    <Router>
      <Header/>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/service/pharmacy" element={<Pharmacy />} />
        <Route
          exact
          path="/service/custompacking"
          element={<CustomPacking />}
        />
        <Route exact path="/service/trx" element={<Trx />} />
        <Route exact path="/service/alf" element={<ALF />} />
        <Route
          exact
          path="/service/medicaladherence"
          element={<MedicalAdherence />}
        />
        <Route exact path="/service/mtherapy" element={<MTheraphy />} />
        <Route
          exact
          path="/service/sterileandnoncompounding"
          element={<SANC />}
        />
        <Route
          exact
          path="/service/immunizations"
          element={<Immunizations />}
        />
        <Route
          exact
          path="/service/multidosepillpackaging"
          element={<MDPP />}
        />
        <Route exact path="/service/medicationsync" element={<MSync />} />
        <Route exact path="/resources/medinfo" element={<MedInfo />} />
        <Route
          exact
          path="/resources/independentvschainpharmacies"
          element={<IVCP />}
        />
        <Route
          exact
          path="/resources/medicationpartd"
          element={<MediacationPartD />}
        />
        <Route exact path="/resources/alcpsp" element={<ALCPSP />} />
        <Route
          exact
          path="/resources/vitaminsarenecessary"
          element={<VitaminsAreNecessary />}
        />
        <Route
          exact
          path="/resources/personalattention"
          element={<PersonalAttention />}
        />
      
      </Routes>

      <Footer/>
    </Router>

  );
}

export default App;
